import { render, staticRenderFns } from "./PriceMaharaja.vue?vue&type=template&id=bbe0a0e4&scoped=true"
import script from "./PriceMaharaja.vue?vue&type=script&lang=js"
export * from "./PriceMaharaja.vue?vue&type=script&lang=js"
import style0 from "./PriceMaharaja.vue?vue&type=style&index=0&id=bbe0a0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe0a0e4",
  null
  
)

export default component.exports